// extracted by mini-css-extract-plugin
module.exports = {"matiers":"matiers_matiers__3JG_g","center":"matiers_center__3XsZ9","__cours":"matiers___cours__1lqLF","right":"matiers_right__suujz"};